import {Component, OnInit, ViewEncapsulation, trigger, state, style, transition, animate} from '@angular/core';
import {AuthenticationService} from "../shared/services/authentication/authentication.service";
import {Router, NavigationStart, NavigationEnd} from "@angular/router";
import {LoadingStateService} from "../shared/services/loading-state.service";

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.css'],
  animations: [
    trigger('slideUpAndDown', [
      state('in', style({height: '*'})),
      state('out', style({height: 0})),
      transition('in => out', [
        animate("0.2s ease-out")
      ]),
      transition('out => in', [
        animate("0.2s ease-in")
      ])
    ])
  ],
  encapsulation: ViewEncapsulation.None
})
export class PageComponent implements OnInit {

  public notificationOptions = {
    timeOut: 5000,
  };

  public collapsed = true;

  constructor(private authenticationService: AuthenticationService,
              private loadingState: LoadingStateService,
              private router: Router) { }

  ngOnInit() {
    this.router.events.subscribe(event => {

      if (event instanceof NavigationStart) {
        this.loadingState.setLoading(true)
      } else if (event instanceof NavigationEnd) {
        this.loadingState.setLoading(false);
      }
    });
  }


  public logout() {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/page/page.component.ts